import Left from "@repo/icons/default/Left";
import { z } from "zod";
import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router";
import { type FragmentType, graphql } from "@repo/graphql-types";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  PaymentReceiptDetails,
  type PaymentReceiptDetailsFragment,
} from "@/components/payment/patient/payment-receipt-details";

import type { JSX } from "react";

const PaymentReceiptPageQuery = graphql(`
  query PaymentReceiptPageQuery($codAgendamento: Int, $onlinePaymentGuid: String) {
    ExpensumPaymentDetails(
      arg1: { onlinePaymentGuid: $onlinePaymentGuid, codAgendamento: $codAgendamento }
    ) {
      ...PaymentReceiptDetailsFragment
    }
  }
`);

const PaymentReceiptPageSearchSchema = z.object({
  guid: z.string().optional(),
  appointmentId: z.number().optional(),
  action: z.string().optional(),
});

const PaymentReceiptPage = (): JSX.Element => {
  const { guid, appointmentId } = useSearch({
    from: "/settings/payments/patient-payments/payment-receipt",
  });

  const queryResult = useGraphQL(PaymentReceiptPageQuery, {
    onlinePaymentGuid: guid,
    codAgendamento: appointmentId,
  });

  const { data } = queryResult;

  const router = useRouter();

  const handleBack = (): void => {
    router.history.back();
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" onClick={handleBack} />
        <HeaderTitle title="Comprovante" align="center" />
      </HeaderRoot>
      <Page className="p-2">
        <AsyncDataWrapper {...queryResult}>
          {data?.ExpensumPaymentDetails ? (
            <PaymentReceiptDetails
              data={
                data.ExpensumPaymentDetails as FragmentType<
                  typeof PaymentReceiptDetailsFragment
                >
              }
            />
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/settings/payments/patient-payments/payment-receipt",
)({
  component: PaymentReceiptPage,
  validateSearch: PaymentReceiptPageSearchSchema,
});
